import { atom } from 'recoil';

export const ShowPositionState = atom({
    key: 'ShowPositionState', 
    default: false, 
});